import React from 'react';

export default function ReturnsIntroduction({
  retailer,
  retailerIntroduction,
  retailerDimensions,
  csReturn,
  useInPostRetailerPageNewCopy,
}) {
  return (
    <div className="retailer__introduction">
      {retailerIntroduction && (
        <div
          dangerouslySetInnerHTML={{ __html: retailerIntroduction }}
        />
      )}

      {!csReturn && (
        <div>
          {retailerDimensions ? (
            <div
              dangerouslySetInnerHTML={{ __html: retailerDimensions }}
            />
          ) : (!useInPostRetailerPageNewCopy && retailer.enablePrintInStore) ? (
            <div>
              <h4>Want to print your label in store?</h4>
              <p>
                No printer? No problem. You can have your label printed in your
                chosen Yodel Store when you take your items to be returned.
                Learn more about using our Print in Store service{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="/help-centre/do-i-need-printer-returns"
                >
                  here
                </a>
                .
              </p>
            </div>
          ) : (
            <div>
              <p>
                {useInPostRetailerPageNewCopy
                  ? `InPost Shops can only accept parcels under 10kg and with maximum dimensions of ${retailer.maxDimensions || '60x50x50cm'}.`
                  : `Yodel Stores can only accept parcels under 10kg and with maximum dimensions of ${retailer.maxDimensions || '60x50x50cm'}.`}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
